import { render, staticRenderFns } from "./RoutinesAuto.vue?vue&type=template&id=60193427&scoped=true"
import script from "./RoutinesAuto.vue?vue&type=script&lang=js"
export * from "./RoutinesAuto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60193427",
  null
  
)

export default component.exports